import styled from 'styled-components';

export const StyledIcon = styled.svg`
    align-items: center;
`;

export const StyledParagraph = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 17px;
  font-weight: 500;
`;

export const StyledTitle = styled.h3`
  text-align: center;
  font-family: Montserrat,Arial black,sans-serif;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 700;
`;

export const StyledDiv = styled.div`
  text-align: center;
  font-size: 14px;
  max-width: 1500px;
  padding: 36px 24px;
`;
